// extracted by mini-css-extract-plugin
export default {"scoreBox":"scoreBox_scoreBox__ipUDc","languageWrapper":"scoreBox_languageWrapper__GBiPR","item":"scoreBox_item__9fPQy"};